import { gql } from '@apollo/client'

export const PAYMENT_INVESTIGATIONS_QUERY = gql`
  query PaymentInvestigations(
    $filter: PaymentInvestigationFilter
    $page: Int
    $perPage: Int
  ) {
    paymentInvestigations(filter: $filter, page: $page, perPage: $perPage) {
      items {
        id
        kind
        reason
        state
        displayReservationNumber
        bookingReference
        observedAt
        resolvedAt
      }
      total
      page
      perPage
    }
  }
`
